<template>
  <delete-dialog-base @remove="remove" :loading="deletingCar">
    <template #activator="{ on, attrs }">
      <slot :on="on" :attrs="attrs">
        <v-icon small class="mr-2" v-bind="attrs" v-on="on">
          mdi-delete
        </v-icon>
      </slot>
    </template>
    <template #headline>Odstrániť auto {{ lazyWorker.Name }}</template>
    <template #form>
      Naozaj chcete odstrániť auto {{ lazyWorker.Name }}?
    </template>
  </delete-dialog-base>
</template>

<script>
import DeleteDialogBase from "./DeleteDialogBase.vue";
import { useDeleteOneCarMutation } from "@/generated/backend";
import { ref, watch } from "vue-demi";

export default {
  components: { DeleteDialogBase },
  props: {
    car: {
      type: Object,
    },
  },

  setup(props, { emit }) {
    const lazyWorker = ref(props.car);
    watch(
      () => props.car,
      (c) => (lazyWorker.value = c)
    );

    const {
      mutate: removeCar,
      loading: deletingCar,
      onDone: deletingFinished,
    } = useDeleteOneCarMutation({});

    const remove = (cb) => {
      deletingFinished((data) => {
        cb();
        emit("removed", data);
      });
      removeCar({
        input: { id: lazyWorker.value.Id },
      });
    };

    return {
      remove,
      lazyWorker,
      deletingCar,
    };
  },
};
</script>

<style></style>
